import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const [currentQuote, setCurrentQuote] = useState(0);
  
  const quotes = [
    "Transform your mind, body, and soul through the ancient practice of yoga.",
    "Discover inner peace, strength, and flexibility in our serene studio environment.",
    "Every pose is a meditation, every breath is a prayer.",
    "Yoga is not about touching your toes, it's about what you learn on the way down."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentQuote((prev) => (prev + 1) % quotes.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [quotes.length]);

  const scrollToAsanas = () => {
    const element = document.getElementById('asanas');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const floatingElements = Array.from({ length: 6 }, (_, i) => (
    <motion.div
      key={i}
      className="floating-element"
      style={{
        position: 'absolute',
        fontSize: '2rem',
        opacity: 0.1,
        color: 'white',
        zIndex: 0,
      }}
      animate={{
        y: [0, -20, 0],
        rotate: [0, 10, -10, 0],
        scale: [1, 1.1, 1],
      }}
      transition={{
        duration: 3 + i,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      initial={{
        top: `${20 + (i * 15)}%`,
        left: `${10 + (i * 15)}%`,
      }}
    >
      🧘‍♀️
    </motion.div>
  ));

  return (
    <section id="home" className="hero">
      {floatingElements}
      
      <motion.div 
        className="hero-content"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ position: 'relative', zIndex: 1 }}
      >
        <motion.h1
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          Welcome to Sanchiti's Fitness Studio
        </motion.h1>
        
        <motion.div
          key={currentQuote}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8 }}
          style={{
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '2rem'
          }}
        >
          <p style={{ fontSize: '1.2rem', textAlign: 'center', opacity: 0.9 }}>
            {quotes[currentQuote]}
          </p>
        </motion.div>

        <motion.div
          style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginBottom: '2rem'
          }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
        >
          <motion.div
            style={{
              background: 'rgba(255,255,255,0.2)',
              padding: '1rem 2rem',
              borderRadius: '50px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.3)'
            }}
            whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.3)' }}
          >
            <strong>40+ Yoga Asanas</strong>
          </motion.div>
          <motion.div
            style={{
              background: 'rgba(255,255,255,0.2)',
              padding: '1rem 2rem',
              borderRadius: '50px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.3)'
            }}
            whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.3)' }}
          >
            <strong>Sanskrit & English</strong>
          </motion.div>
          <motion.div
            style={{
              background: 'rgba(255,255,255,0.2)',
              padding: '1rem 2rem',
              borderRadius: '50px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.3)'
            }}
            whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.3)' }}
          >
            <strong>Expert Guidance</strong>
          </motion.div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
          style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}
        >
          <motion.a 
            href="#asanas" 
            className="cta-button" 
            onClick={scrollToAsanas}
            whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(0,0,0,0.2)" }}
            whileTap={{ scale: 0.95 }}
          >
            🧘‍♀️ Explore Yoga Asanas
          </motion.a>
          <motion.a 
            href="#contact" 
            style={{
              display: 'inline-block',
              background: 'transparent',
              color: 'white',
              padding: '1rem 2rem',
              textDecoration: 'none',
              borderRadius: '50px',
              fontWeight: 'bold',
              border: '2px solid white',
              transition: 'all 0.3s ease'
            }}
            whileHover={{ 
              scale: 1.05, 
              background: 'white', 
              color: '#667eea',
              boxShadow: "0 10px 25px rgba(255,255,255,0.2)" 
            }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            📞 Book a Class
          </motion.a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
